import React from 'react';
import { Stack, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../../config/app.config';
import { BorderedBlock } from '@shared/ui/common/BorderedBlock';
import { InventoryStatus } from '@features/inventory';
import { ProductInventory } from '@domain/inventory/models/Inventory';

interface ProductInventoryPreviewProps {
  inventory: ProductInventory | null | undefined;
}

const ProductInventoryPreview: React.FC<ProductInventoryPreviewProps> = ({ inventory }) => (
  <BorderedBlock header="Inventory">
    <Stack direction="row" alignItems="center" spacing={4}>
      <Stack direction="column" alignItems="center" justifyContent="center" spacing={0} borderRight={1} borderColor={APP_CONFIG.ui.theme.colors.border} pr={2}>
        <Typography variant="h6" color="text.secondary">
          {inventory?.quantity || 0}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          Items in stock
        </Typography>
      </Stack>
      {inventory ? (
        <InventoryStatus inventory={inventory} />
      ) : (
        <Typography variant="subtitle2" color="text.secondary">No inventory data available</Typography>
      )}
    </Stack>
  </BorderedBlock>
);

export default ProductInventoryPreview;
